import { __awaiter, __generator } from "tslib";
import { punchCardRowKey } from '.';
export var createPunchCardRowDriver = function (wrapper, idx) {
    if (idx === void 0) { idx = 0; }
    var base = wrapper.$$("." + punchCardRowKey).get(idx);
    return {
        label: function () { return base.$('.row-label').text(); },
        scaleAmounts: function () {
            return base.$$('.value-bubble').map(function (b) { return __awaiter(void 0, void 0, void 0, function () {
                var amout;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, b.attr('data-scale')];
                        case 1:
                            amout = _a.sent();
                            return [2 /*return*/, parseFloat(amout || '')];
                    }
                });
            }); });
        },
        base: base
    };
};
//# sourceMappingURL=driver.js.map